module.exports = __webpack_public_path__ + "img/billion-tab.070dbd1a.png";